import { render, staticRenderFns } from "./unitEditorModal.vue?vue&type=template&id=523ce666&scoped=true"
import script from "./unitEditorModal.vue?vue&type=script&lang=js"
export * from "./unitEditorModal.vue?vue&type=script&lang=js"
import style0 from "./unitEditorModal.vue?vue&type=style&index=0&id=523ce666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ce666",
  null
  
)

export default component.exports